<app-test-flags></app-test-flags>
<div id="login" class="inner-scroll" appFlexLayout="row" appFlexAlign="start">

  <div id="login-intro" appFlex fxHide fxShow.gt-xs>

    <div class="logo" [@animate]="{value:'*',params:{scale:'0.2'}}">
      <img src="assets/images/logos/logo-text_white.svg">
    </div>

    <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}">
      {{ 'Validez plus, testez mieux' | translate }}
    </div>

    <div class="description" [@animate]="{value:'*',params:{delay:'100ms',y:'25px'}}">
      {{ 'Appuyez vos décisions sur des données clients lors du développement de vos produits' | translate }}
    </div>

  </div>

  <div id="login-form-wrapper" fusePerfectScrollbar [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}">

    <div id="login-form">

      <div class="logo" fxHide.gt-xs>
        <img src="assets/images/logos/logo_green.png">
      </div>

      <div class="title" translate="">Identification</div>

      <!-- Login Block TOKEN LOGIN     -->
      <ng-container *ngIf="token">

        <div class="mt-24">

          <mat-error *ngIf="(getState$ | async) as errorMessage" role="alert">
            <div *ngIf="errorMessage.fullMessage">
              <pre>{{ errorMessage.fullMessage?.error?.error?.error?.message | json }}</pre>
            </div>
          </mat-error>

          <mat-card>
            <mat-card-header>

              <mat-card-title>
                <i class="mdi mdi-key-wireless"></i>
                {{ 'Identification' | translate }}
              </mat-card-title>

            </mat-card-header>
            <mat-card-content>
              <div appFlexLayout="column" appFlexAlign="center center" style="min-height: 100px;">
                <div appFlex="1" appFlexLayout style="align-items: center;">
                  <mat-spinner [diameter]="24"></mat-spinner>
                  <span class="t2 ml-16">{{ 'Redirection en cours'|translate }}...</span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

        </div>

      </ng-container>


      <!-- Login Block classique     -->
      <ng-container *ngIf="!token">

        <mat-error *ngIf="(getState$ | async) as errorMessage" role="alert">
          <span>
            {{ errorMessage.errorMessage }}
          </span>
        </mat-error>

        <form name="loginForm" [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>

          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" data-testid="email-input">
            <mat-icon matSuffix class="secondary-text">mail</mat-icon>
            <mat-error *ngIf="loginForm.get('email').hasError('required')">
              Email is required
            </mat-error>
            <mat-error *ngIf="!loginForm.get('email').hasError('required') &&
                                loginForm.get('email').hasError('email')">
              Please enter a valid email address
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="mt-16">
            <mat-label>Password</mat-label>
            <input matInput type="password" formControlName="password" data-testid="password-input">
            <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
            <mat-error>
              Password is required
            </mat-error>
          </mat-form-field>

          <button mat-raised-button color="accent" class="submit-button" aria-label="LOGIN" data-testid="login-btn"
            [disabled]="loginForm.invalid" style="color: white;">
            {{ 'Connexion'|translate }}
          </button>

        </form>

      </ng-container>
    </div>
  </div>
</div>
